/**
 * 对象转query字符串
 */
export function objToQueryType(obj: Record<string, any>, isEncode = true) {
  if (!obj) return '';
  return Object.keys(obj)
    .map((key) => {
      let dataStr = '';
      if (typeof obj[key] === 'object') {
        dataStr = JSON.stringify(obj[key]);
      } else {
        dataStr = String(obj[key]);
      }
      return isEncode
        ? `${key}=${encodeURIComponent(dataStr)}`
        : `${key}=${dataStr}`;
    })
    .join('&');
}
